import styled from 'styled-components'
import { TCheckinWidgetTypes } from 'interface'

export const DayWidget = styled.div<{
  $border?: string
  $borderColor?: string
  $bgColor?: string
  state: TCheckinWidgetTypes
}>`
  position: relative;

  display: flex;
  flex-direction: ${({ state }) =>
    state.includes('DAY_7') && state !== 'DAY_7_CHECKED' ? 'row-reverse' : 'row'};
  gap: 12px;
  justify-content: space-between;
  align-items: center;

  padding: 24px 16px;
  width: 100%;
  height: 100%;

  background-color: ${({ $bgColor }) => $bgColor};

  border-radius: 8px;
  border: ${({ $border, $borderColor }) => `1px ${$border} ${$borderColor}`};
`

export const DayInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const IconContainer = styled.div`
  width: fit-content;
`

export const Circle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  border: 2px solid var(--gray200);
`

export const OrangeFridayBand = styled.img`
  position: absolute;
  top: 0;
  right: 0;
`
